import Api from './api';

const slug = 'v1/booking-slots';

export default {
  getBookingSlot(slotId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${slotId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteBookingSlot(slotId) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${slotId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteBookingSlots(slotIds) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/batch`, {
        data: {
          slotIds,
        },
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getBookingSlots(params = {}) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/search`, {
        params,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  createBookingSlots(bookingSlots) {
    return new Promise((resolve, reject) => {
      const data = {
        slotsData: bookingSlots,
      };

      Api.post(`/${slug}/`, data)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  bookSlot(slotId, programId) {
    return new Promise((resolve, reject) => {
      Api.patch(`/${slug}/${slotId}/programs/${programId}/book`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  releaseSlot(slotId) {
    return new Promise((resolve, reject) => {
      Api.patch(`/${slug}/${slotId}/release`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
